const DASHBOARD = {
  DASHBOARDS: 'DASHBOARDS',
  DASHBOARD: 'DASHBOARD',
  DASHBOARD_PARTNERTYPE: 'DASHBOARD_PARTNERTYPE',
  DASHBOARD_ARRIVALS_TODAY: 'DASHBOARD_ARRIVALS_TODAY',
  DASHBOARD_DEPARTURES_TODAY: 'DASHBOARD_DEPARTURES_TODAY',
};

export default DASHBOARD;
